import { render, staticRenderFns } from "./FarmsEditFormFields.vue?vue&type=template&id=ede20250&scoped=true"
import script from "./FarmsEditFormFields.vue?vue&type=script&lang=js"
export * from "./FarmsEditFormFields.vue?vue&type=script&lang=js"
import style0 from "./FarmsEditFormFields.vue?vue&type=style&index=0&id=ede20250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede20250",
  null
  
)

export default component.exports